export default __webpack_public_path__ + "static/media/header.83148fc6.jpg";